import { useCallback } from 'react';
import { useBrandMainSupplierSetMutation } from 'api';
import { useParams } from 'react-router-dom';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useMainSupplierSetModal = ({
  onModalStateChange,
  supplierId,
}: {
  onModalStateChange: () => void;
  supplierId: string | null;
}) => {
  const { id } = useParams() as { id: string };
  const [setMainSupplier, { isLoading }] = useBrandMainSupplierSetMutation();

  const handleCancel = useCallback(() => {
    onModalStateChange();
  }, [onModalStateChange]);

  const [notificationApi, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const handleSubmit = useCallback(async () => {
    try {
      const payload = {
        supplierId,
        brandId: id,
      };
      const { data, error }: Record<string, any> = await setMainSupplier(payload);
      if (data?.success) {
        openNotificationWithIcon({
          type: 'success',
          message: 'Supplier was successfully set as main.',
        });
        handleCancel();
      } else if (error?.data?.success === false) {
        Object.values(error?.data?.data || {}).forEach((message) => {
          openNotificationWithIcon({
            type: 'error',
            message: message as string,
          });
        });
      } else if (error?.data?.error) {
        openNotificationWithIcon({
          type: 'error',
          message: 'Something went wrong!',
        });
      }
    } catch (err) {
      console.error('Error setting main supplier:', err);
      openNotificationWithIcon({
        type: 'error',
        message: 'An unexpected error occurred. Please try again.',
      });
    }
  }, [id, openNotificationWithIcon, handleCancel, setMainSupplier, supplierId]);

  return {
    handleCancel,
    handleSubmit,
    contextHolder,
    isLoading,
  };
};
